export default __webpack_public_path__ + "static/media/BiosensorFigure6.ee4fd404.svg";